import React, { FC, createContext } from 'react';
import { OfficePageNewDTO } from '~js/React/types/UmbracoOfficeInterface';
import { OfficeAdminPageDTO } from '~js/React/types/UmbracoOfficeAdminPageInterface';
import useUmbracoOffice from '~js/React/components/CustomHooks/useUmbracoOffice';
import useUmbracoContentType from '~js/React/components/CustomHooks/useUmbracoContentType';
import useUmbracoContent from '~js/React/components/CustomHooks/useUmbracoContent';

export enum SectionId {
  Overview = 'overview',
  News = 'news',
  Objects = 'objects',
  Brokers = 'brokers',
  SoldObjects = 'soldobjects',
  Partners = 'partners',
}
interface OfficePageContextTypes {
  office: OfficePageNewDTO | null;
  officeAdminPage: OfficeAdminPageDTO | null;
  archiveId?: string;
}

type Props = {
  children: React.ReactNode;
  pageId: string;
  archiveId?: string;
};

export const OfficePageContext = createContext<OfficePageContextTypes>(
  {} as OfficePageContextTypes
);

const OfficePageContextProvider: FC<Props> = ({
  children,
  pageId,
  archiveId,
}) => {
  const { data: officeAdminPage } = useUmbracoContentType('BrokerPages', true);

  const { data: office } = useUmbracoOffice<OfficePageNewDTO>(pageId);

  const officePageContextObject: OfficePageContextTypes = {
    office,
    officeAdminPage,
    archiveId,
  };

  return (
    <OfficePageContext.Provider value={officePageContextObject}>
      {children}
    </OfficePageContext.Provider>
  );
};

export default OfficePageContextProvider;
